Drupal.behaviors.mpp_custom_v1 = {
  attach: function (context, settings) {
    var productsData = page_data['product-input-type'].products;

    site.productView.mpp.init(productsData);
    // product sort
    site.productSort.init(productsData);
  }
};
